import { graphql, Link, useStaticQuery } from 'gatsby'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import { indexesAsArray, shuffleArray } from '../../../helpers/arrays'
import Button from '../../button/Button'

const LatestRandom = () => {
  let data = getData()
  const articleData = data['allContentfulArticle'].edges 
  if (!articleData || articleData.length === 0) return <>No Data</>

  const latestItem = articleData[0].node
  const itemIndexes: number[] = shuffleArray(indexesAsArray(articleData.length))

  let amountPicked = 0
  const randomItems = []
  for (let i = 0; i < itemIndexes.length; i++) {
    const { contentful_id } = articleData[itemIndexes[i]].node

    if (amountPicked === 2) break
    if (contentful_id === latestItem.contentful_id) continue

    randomItems.push(articleData[itemIndexes[i]].node)
    amountPicked++
  }

  return (
    <div className={`bg-gradient-to-tr py-12 md:py-24 from-c-gradient-blue-left to-c-gradient-blue-right`}>
      <div className='container mx-auto px-5'>
        <div className='font-header text-3xl uppercase italic mb-3 text-left text-black'>Highlights</div>
        <BigItem data={latestItem} />
        <div className='flex flex-col md:justify-between flex-wrap md:flex-row gap-x-5 gap-y-5 mt-8 md:mt-16'>
          {randomItems.map((item, key) => {
            return <SmallItem data={item} key={key} />
          })}
          <div className='md:basis-full lg:basis-0 md:mt-5 lg:mt-0 lg:flex-1'>
            <div className='flex md: flex-col gap-y-5 justify-end items-center md:items-end'>
              <StaticImage className="hidden md:block" src={'../../../images/white-transparent-arrow.png'} alt="Arrow" height={232} />
              <Button kind='anchor' className='whitespace-nowrap' appearance='hollow-white' to={'/highlights/'}>
                Se fler highlights
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LatestRandom

const BigItem = ({
  data,
}: {
  data: Queries.AllLatestRandomHighlightBlockQuery['allContentfulArticle']['edges'][0]['node']
}) => {
  return (
    <div className='flex flex-col-reverse gap-y-5 lg:flex-row gap-x-5 justify-between'>
      <div className='basis-2/4 text-left'>
        <div className='font-header text-white text-3xl md:text-6xl lg:text-[88px] uppercase mb-5 break-words'>{data.title}</div>
        {data.excerpt && <div className='text-white'>{data.excerpt?.excerpt}</div>}
        <div className='font-bold text-center md:text-left font-title uppercase text-black pt-5'>
          <Link to={`/post/${data.slug}`} className='hover:underline'>
            Läs hela inlägget
          </Link>
        </div>
      </div>
      <div className='text-left'>
        {data.images !== null && data.images.length > 0 && (
          <>
            {data.images[0] !== null && data.images[0].gatsbyImageData !== null && (
              <div>
                <GatsbyImage  alt={data.images[0].title ? data.images[0].title : 'Bild'} image={data.images[0].gatsbyImageData} />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

const SmallItem = ({
  data,
}: {
  data: Queries.AllLatestRandomHighlightBlockQuery['allContentfulArticle']['edges'][0]['node']
}) => {
  return (
    <div className='relative w-full h-[250px] md:w-[350px] lg:w-[470px] lg:h-[332px] overflow-hidden'>
      {data.images !== null && data.images.length > 0 && (
        <>
          {data.images[0] !== null && data.images[0].gatsbyImageData !== null && (
            <div className='absolute z-10'>
              <GatsbyImage
                alt={data.images[0].title ? data.images[0].title : 'Bild'}
                image={data.images[0].gatsbyImageData}
                className='w-full h-[250px] lg:w-[470px] lg:h-[332px] overflow-hidden'
              />
            </div>
          )}
        </>
      )}
      <div className={`absolute z-20 w-full h-full bg-gradient-to-tr from-c-gradient-image-pink-left via-c-gradient-image-pink-middle/60 to-c-gradient-image-pink-right`}></div>
      <div className='absolute z-30 bottom-10 flex flex-col items-start'>
        <div className='mb-6 pl-8 font-bold text-3xl text-white w-3/4 text-left overflow-hidden max-h-[140px] md:max-h-[140px] lg:max-h-full'>{data.title}</div>
        <div className='pl-8'>
          <Button kind='anchor' appearance='hollow-white' to={`/post/${data.slug}`}>
            Läs inlägg
          </Button>
        </div>
      </div>
    </div>
  )
}

const getData = ():Queries.AllLatestRandomHighlightBlockQuery => {
  return useStaticQuery(graphql`
    query AllLatestRandomHighlightBlock {
      allContentfulArticle(filter: { title: { regex: "/^(?!.*(^dummy))/gi" }, highlight: {eq: true} }) {
        edges {
          node {
            contentful_id
            __typename
            id
            title
            highlight
            slug
            date
            excerpt {
              excerpt
            }
            images {
              gatsbyImageData(formats: WEBP, quality: 75, width: 470, placeholder: BLURRED)
              title
            }
          }
        }
      }
    }
  `)
}
